/* eslint-disable no-undefined */
/* eslint-disable no-inline-comments */
/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MUIDataTable from 'mui-datatables'
import { connect } from 'react-redux'
import {
  createTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import EmailIcon from '@material-ui/icons/Email'
import EditIcon from '@material-ui/icons/Edit'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'
import Link from '@material-ui/core/Link'
import TableRow from '@material-ui/core/TableRow'
import { LIGHTBLUE, LIGHTGREY, DEEPORANGE } from '../../utils/color_utils'
import { getAllCompanyGroupUsers } from '../../store/actions/companyAdminActions'
import Checkbox from '@material-ui/core/Checkbox';
import { Radio } from '@mui/material';
import firebase from '../../store/firebase'
import { showToast, clearStates } from '../../store/actions/toastAction'
import { FB_URL } from '../../store/actions/types';
import axios from 'axios';
//import { SHOW_TOAST } from '../../store/actions/types'

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginLeft: theme.spacing(),
    marginRight: theme.spacing()
  },
  group_userslabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: `${LIGHTBLUE}`,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    // borderBottom: `1px solid ${LIGHTGREY}`,
    padding: theme.spacing()
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  groupText: {
    fontSize: '0.875rem!important'
  },
  badge: {
    backgroundColor: DEEPORANGE,
    padding: 3,
    borderRadius: 4,
    color: '#fff',
    marginLeft: '12px'
  },
  table: {
    minWidth: 650
  }
})


class GroupUsers extends Component {
  state = {
    page: 0,
    rowsPerpage: 10,
    groupId: null,
    currentCreatorId: ''
  };

  componentDidMount() {
    console.log('start props: ', this.props);
    this.GetCreator(this.props.groupId);
    if (this.state.groupId !== this.props.groupId) {
      this.setState({ ...this.state, groupId: this.props.groupId })
      this.fetchGroupUsers()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevProps.groupId !== this.props.groupId) {
    //   this.fetchGroupUsers()
    // }
  }

  fetchGroupUsers() {
    this.props.getAllCompanyGroupUsers({
      companyID: this.props.userdata.companyID,
      groupID: this.props.groupId
    })
  }

  getMuiTheme = () =>
  createTheme({
      overrides: {
        MitemataTable: {
          root: {
            backgroundColor: '#FF000'
          },
          paper: {
            boxShadow: 'none'
          },
          responsiveScroll: {
            marginTop: '50px'
          }
        },
        MitemataTableHeadCell: {
          root: {
            padding: '0px',
            verticalAlign: 'top!important'
          },
          head: {
            fontSize: '0.7rem',
            fontWeight: '500',
            padding: '0px',
            verticalAlign: 'textTop'
          }
        },
        MitemataTableBodyCell: {
          root: {
            borderBottom: '0px',
            fontSize: '0.70rem!important',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            padding: '0px 8px 0px 0px'
          }

        },
        MitemataTableSelectCell: {
          root: {
            borderBottom: '0px'
          }
        },
        MitemataTableToolbarSelect: {
          root: {
            display: 'inlineBlock'
          }
        }
      }
    });
  columns = [
    {
      name: 'Firstname',
      options: { filter: true }
    },
    {
      name: 'Lastname',
      options: { filter: true }
    },
    {
      name: 'Email',
      options: { filter: true }
    }
  ];

  options = {
    filterType: 'radio',
    sort: true,
    rowHover: true,
    responsive: 'scroll',
    print: false,
    download: false,
    selectableRows: 'single',
    fixedHeader: false,
    tableHeaderStyle: { borderRight: '40px solid transparent' }
  };

  transformTableData = () => {
    let { classes, userdata, getAllCompanygroup_Users, group_users } = this.props

    let dataListClone = group_users &&
      Object.keys(group_users).map(item => {
        return [

          group_users[item].firstName,
          group_users[item].lastName,
          group_users[item].email
        ]
      })

    return dataListClone
  };
  handleSelectedUser = currentRowsSelected => {
    // this.setState({
    //  selectedRowData: {
    //    uid: rowUserData[5].props.id,
    //    userID: rowUserData[5].key,
    //    firstName: rowUserData[1],
    //    lastName: rowUserData[2],
    //    email: rowUserData[3],
    //    userType: rowUserData[4]
    //  }
    // });
  };

  click = () => {
  }

  sendWelcomeEmail = () => e => {
    }

  editGroup = () => e => {
    }

  updateGroupUser = async (companyID, groupID, userID, firstName, lastName, email, active) => {
    try {
      const userData = {
        can_add_remove_users: false,
        can_edit: false,
        can_post: false,
        company_ID: companyID,
        company_name: "MeVision",
        email: email,
        firstName: firstName,
        lastName: lastName,
        userID: userID,
        active: active,
        admin: false
      };
      
      

      await firebase.database
        .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
        .set(userData);

      let params = {
        type: 'SHOW_TOAST',
        open: true,
        variant: 'success',
        message: active
          ? 'Group participant has been activated.'
          : 'Group participant has been deactivated.',
      };

      this.props.showToast(params);
    } catch (error) {
      
    }
  };

  canPostGroupUser = async (companyID, groupID, userID, firstName, lastName, email, canpost) => {
    try {
      const snapshot = await firebase.database
        .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
        .once('value');
  
      if (!snapshot.exists()) {
        
        let params = {
          type: 'SHOW_TOAST',
          open: true,
          variant: 'error',
          message: 'User not found in group.',
        };
        this.props.showToast(params);
        return;
      }
  
      await firebase.database
        .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
        .update({
          can_post: canpost,
        });
  
      let params = {
        type: 'SHOW_TOAST',
        open: true,
        variant: 'success',
        message: `User's posting permission has been ${canpost ? 'enabled' : 'disabled'}.`,
      };
  
      this.props.showToast(params);
    } catch (error) {
      
      let params = {
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Failed to update posting permission.',
      };
      this.props.showToast(params);
    }
  };

  handleCheckboxChange = (companyID, groupID, userID, firstName, lastName, email) => (event) => {
    const isChecked = event.target.checked;
    
    this.updateGroupUser(companyID, groupID, userID, firstName, lastName, email, isChecked);
  };
  
  handleCanPostChange = (companyID, groupID, userID, firstName, lastName, email) => (event) => {
    const isChecked = event.target.checked;
    this.canPostGroupUser(companyID, groupID, userID, firstName, lastName, email, isChecked);
  };

 async findUserType(userID) {
  if (!userID) {
    throw new Error("userID is required");
  }

  const db = firebase.database;
  const userRef = db.ref(`users/${userID}`);

  try {
    const snapshot = await userRef.once("value");

    if (!snapshot.exists()) {
      return null;
    }

    const data = snapshot.val();
    return data.userType ?? null;  // or "unknown", "regular", etc.
  } catch (error) {
    console.error("Error reading userType:", error);
    throw error;
  }
}

handleRadioChange = async(companyID, groupId, newCreatorUserID) => {
  // Optional: early return if same value (prevents unnecessary writes)
  console.log('handleRadioChange companyID:', companyID, typeof companyID);
  console.log('handleRadioChange groupId:', groupId, typeof groupId);
  console.log('handleRadioChange newCreatorUserID:', newCreatorUserID, typeof newCreatorUserID);

  if (this.state.currentCreatorId === newCreatorUserID) {
    return;
  }
  const newCreatorUserType = await this.findUserType(newCreatorUserID);

  if (newCreatorUserType !== 21) {
     let toastparams = {
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Selected user is not a group Admin.',
      };
      this.props.showToast(toastparams); 
    return;
  } 
  console.log('handleRadioChange 0');
  const db = firebase.database;           // or this.props.firebase.database()
 // const groupRef = db.ref(`company_groups/${companyID}/${groupId}`);
  const groupRef = `company_groups/${companyID}/${groupId}/group_creator`;
  console.log('handleRadioChange 1', groupRef);
  // Option 1: Set only the group_creator field (recommended)
          var updates = {};
         updates[groupRef] = newCreatorUserID;

        var res = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: updates, //user wallet address                       
              }
        })

        if (res.data || res.data.success === true) {
           console.log("Group creator updated successfully");
            this.setState({ currentCreatorId: newCreatorUserID });
        }
        else {
           console.log("Failed to change group creator. Please try again.");
        }
  // groupRef.child('group_creator').set(newCreatorUserID)
  //   .then(() => {
  //     console.log("Group creator updated successfully");
  //      console.log('handleRadioChange 2');
  //     // Optional: update local state for instant UI feedback
  //     this.setState({ currentCreatorId: newCreatorUserID });
  //   })
  //   .catch(err => {
  //     console.error("Failed to update group creator:", err);
  //     // Optional: show error toast/notification
  //     alert("Failed to change group creator. Please try again.");
  //   });

  // Option 2: If you want to do a transaction (safer but more complex)
  /*
  groupRef.transaction((currentData) => {
    if (currentData === null) return null; // abort if doesn't exist
    return {
      ...currentData,
      group_creator: newCreatorUserID
    };
  });
  */
};

GetCreator = async (groupId) => {
  if (!groupId || typeof groupId !== 'string') {
    console.log('GetCreator: Invalid groupId provided');
    return null;
  }
  console.log('GetCreator groupId: ', groupId);
  try {

      const db = firebase.database;
      const compId = this.props.userdata.companyID
      const groupRef = db.ref(`company_groups/${compId}/${groupId}`);

      const snapshot = await groupRef.once('value');
      if (!snapshot.exists()) { 
        console.log('GetCreator err');
        return;
      }

    const groupData = snapshot.val();
    console.log('GetCreator currentCreatorId: ', groupData);

    this.setState({
      currentCreatorId: groupData?.group_creator || null
    })
    // Return the creator UID or null if missing
   // return groupData?.group_creator || null;
  } catch (error) {
    console.error('GetCreator failed:', error);
    return null;
  }
};

  render() {
    const { classes, group_users } = this.props;
    const { currentCreatorId } = this.state;

    console.log('group props 1: ', this.props.userdata.companyID);
    
    //const group_creator = this.GetCreator(this.props.groupId);
    console.log('group props 2: ', currentCreatorId);

    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={7} style={{ textAlign: 'left' }} className={classes.root}>
            <Typography
              className={classes.group_userslabel}
              variant='subtitle2'
              gutterBottom
            >
              <Link onClick={this.click}>Group Participants</Link>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={4} style={{ textAlign: 'left' }}>
            <Button
              variant='outlined'
              color='primary'
              size='small'
              onClick={this.props.sendWelcomeEmail}
            >
              <EmailIcon className={classes.leftIcon} fontSize='small' />
              SEND WELCOME EMAIL
            </Button>
          </Grid>
          {/* <Grid item xs={6} sm={2} style={{ textAlign: 'left' }}>
            <Button
              variant='outlined'
              color='primary'
              size='small'
              onClick={this.editGroup()}
            >
              <EditIcon className={classes.leftIcon} fontSize='small' />
              EDIT GROUP
            </Button>
          </Grid> */}
          <Grid item xs={12} sm={12} style={{ textAlign: 'left' }}>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell>First Name </TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Activated</TableCell>
                    <TableCell>Can Post</TableCell>
                    <TableCell>Group Admin</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {group_users &&
                    Object.keys(group_users).map(item => {
                      return (
                        <TableRow key={group_users.groupId}>
                          <TableCell component='th' scope='row'>
                            {group_users[item].firstName}
                          </TableCell>
                          <TableCell>{group_users[item].lastName}</TableCell>
                          <TableCell>{group_users[item].email}</TableCell>
                          <TableCell>
                            <Checkbox
                              checked={group_users[item].active || false} // Set checked state based on active field
                              onChange={this.handleCheckboxChange(
                                this.props.userdata.companyID,
                                this.props.groupId,
                                group_users[item].userID,
                                group_users[item].firstName,
                                group_users[item].lastName,
                                group_users[item].email
                              )}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell> 
                          <Checkbox
                              checked={group_users[item].can_post || false} // Set checked state based on active field
                              onChange={this.handleCanPostChange(
                                this.props.userdata.companyID,
                                this.props.groupId,
                                group_users[item].userID,
                                group_users[item].firstName,
                                group_users[item].lastName,
                                group_users[item].email
                              )}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell>
                            <Radio
                              name={`group-creator-${this.props.groupId}`}
                              checked={group_users[item].userID === currentCreatorId}
                              onChange={() => this.handleRadioChange(
                                this.props.userdata.companyID,
                                this.props.groupId,
                                group_users[item].userID,
                              )}
                              color="primary"
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })}
                </TableBody>

              </Table>
            </TableContainer>
          </Grid>
        </Grid>

      </div>
    )
  }
}

GroupUsers.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedGroup: PropTypes.func.isRequired
}


const GroupUsersStyled = withStyles(styles)(GroupUsers)

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    company_groups: state.users.company_groups,
    group_users: state.users.group_users
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showToast: params => dispatch(showToast(params)),
    getAllCompanyGroupUsers: params => dispatch(getAllCompanyGroupUsers(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupUsersStyled)
